import React from "react";
import { Leaf, ArrowDown } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/5cecabe4-e4eb-45e0-b6c1-8159d1b3833b/images/3f9261fa51a8f738b2d2706b74bd7ff300649a3694fa146d488ae8c4cd16e5a7.png";

export default function Hero({ onJump }) {
  return (
    <section
      data-testid="hero-section"
      className="relative isolate overflow-hidden grain"
    >
      <div
        className="absolute inset-0 -z-10"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 -z-10 bg-[#F9F8F6]/90" />

      <div className="max-w-7xl mx-auto px-6 sm:px-12 pt-28 pb-32 lg:pt-40 lg:pb-44">
        <div className="fade-up max-w-4xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/60 backdrop-blur border border-[#E5E2DC] text-[11px] tracking-[0.22em] uppercase text-[#2B5339] font-semibold">
            <Leaf size={12} /> free forever · no signup · no paywall
          </div>

          <h1 className="font-display mt-8 text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-light text-[#1C2B23]">
            Plan a hundred-year retirement,
            <span className="italic font-normal text-[#2B5339]"> grounded in today's markets.</span>
          </h1>

          <p className="mt-8 text-base sm:text-lg text-[#5C6B62] max-w-2xl leading-relaxed">
            A serious retirement planner that runs Monte Carlo simulations against
            <span className="text-[#1C2B23] font-medium"> live market returns</span> — projecting your
            portfolio year by year all the way to age 100. No accounts. No upsells. Just math, honest assumptions, and your numbers.
          </p>

          <div className="mt-10 flex items-center gap-4">
            <button
              data-testid="hero-cta-start"
              onClick={onJump}
              className="bg-[#2B5339] text-white hover:bg-[#1E3B28] rounded-full px-7 py-3.5 transition-colors text-sm font-medium inline-flex items-center gap-2"
            >
              Start the calculator <ArrowDown size={14} />
            </button>
            <a
              data-testid="hero-cta-learn"
              href="#how-it-works"
              className="text-sm text-[#1C2B23] underline-offset-4 hover:underline"
            >
              How it works →
            </a>
          </div>
        </div>

        <div className="fade-up mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-3xl">
          {[
            { k: "100", v: "year horizon" },
            { k: "1,500+", v: "monte carlo runs" },
            { k: "Live", v: "market returns" },
            { k: "$0", v: "forever" },
          ].map((s) => (
            <div key={s.v}>
              <div className="font-display text-3xl sm:text-4xl tracking-tighter text-[#1C2B23] font-mono-num">{s.k}</div>
              <div className="text-[11px] tracking-[0.2em] uppercase text-[#5C6B62] font-semibold mt-1">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
